import { render, staticRenderFns } from "./studentContract.vue?vue&type=template&id=9bb80726&scoped=true&"
import script from "./studentContract.vue?vue&type=script&lang=js&"
export * from "./studentContract.vue?vue&type=script&lang=js&"
import style0 from "./studentContract.vue?vue&type=style&index=0&id=9bb80726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb80726",
  null
  
)

export default component.exports